import { CookieManager } from '@bitskico/sveltekit-cookie-manager';
import { OAUTH_PROXY_HOOKS_OVERRIDES_COOKIE } from '../constants.js';
import { getCookieSettings } from '../config.js';
import { daysFromNow } from '../utils.js';
/**
 * These functions are used on the client to manage proxy overrides. They
 * are meant to be used by internal tooling such as the Bitski dev panel.
 */
export const cookieManager = new CookieManager({
    deviceId: {
        key: () => getCookieSettings().deviceIdName,
        validator: (z) => z.string().min(1),
        serialize: () => ({
            ...getCookieSettings().serializeOptionsDevice,
            sameSite: 'none',
            httpOnly: false,
            expires: daysFromNow(400),
        }),
    },
    devOverrides: {
        key: OAUTH_PROXY_HOOKS_OVERRIDES_COOKIE,
        validator: (z) => z.object({
            showLoggedOutState: z.boolean().optional(),
            mockUser: z
                .object({
                id: z.string(),
                accounts: z.array(z.string()).optional(),
                preferredUsername: z.string().optional(),
                email: z.string().optional(),
                emailVerified: z.boolean().optional(),
                sid: z.string().optional(),
                phoneNumber: z.string().optional(),
                phoneNumberVerified: z.boolean().optional(),
                defaultPhoneNumberId: z.string().optional(),
            })
                .optional(),
        }),
    },
});
